"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kvPrefix = exports.KvWatchInclude = void 0;
var KvWatchInclude;
(function (KvWatchInclude) {
    /**
     * Include the last value for all the keys
     */
    KvWatchInclude["LastValue"] = "";
    /**
     * Include all available history for all keys
     */
    KvWatchInclude["AllHistory"] = "history";
    /**
     * Don't include history or last values, only notify
     * of updates
     */
    KvWatchInclude["UpdatesOnly"] = "updates";
})(KvWatchInclude || (exports.KvWatchInclude = KvWatchInclude = {}));
exports.kvPrefix = "KV_";
//# sourceMappingURL=types.js.map